import HugValue from './HugValue.vue';
import FlexColumn from "@/components/FlexColumn.vue";
import SlotWithEvolutionValue from "./SlotWithEvolutionValue.vue";
import NumberValue from './NumberValue.vue';
import HashedNumberValue from './HashedNumberValue.vue';
import EvolutionValue from "./EvolutionValue.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import SimpleAreaChart from '../charts/SimpleAreaChart.vue';
export default {
  name: "BsrValueWithGraph",
  components: {
    HugValue,
    NumberValue,
    FlexColumn,
    SlotWithEvolutionValue,
    HashedNumberValue,
    EvolutionValue,
    WrapWithPopover,
    SimpleAreaChart
  },
  props: {
    value: [Number, null],
    category: String,
    categoryLink: String,
    evolution: [Number, null],
    evolCharCount: Number,
    activated: Boolean,
    loading: Boolean,
    sparkline: Array,
    max: Number,
    min: Number,
    last_item: Boolean,
    highlightRange: Object,
    single: Boolean
  }
};